import * as angular from 'angular';
import * as _ from 'lodash';
import './styling.scss';
import * as template from './template.html';
import { openUrlInNewTab } from 'common/source/utilities/windowHelper';
import * as hippoConstFactory from 'common/hippoConst';

const module = angular.module('hippo-home-care-card', []);

interface HippoHomeCareCardController extends angular.IStrictController {
    openHippoHomeCarePage: () => void;
}

module.component('hippoHomeCareCard', {
    template: template,
    controller: function(this: HippoHomeCareCardController) {
        const HIPPO_CONST = hippoConstFactory();

        this.openHippoHomeCarePage = () => {
            openUrlInNewTab(HIPPO_CONST.HIPPO_HOME_CARE_URL);
        };
    }
});

export { module };
